module.exports = __webpack_public_path__ + "img/zxjs2.aee77787.png";